var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: {
        title: _vm.$t("billing.invoiceSettings"),
        "cancel-text": _vm.$t("message.cancel"),
        "ok-text": _vm.$t("message.confirm"),
        "show-footer": true,
      },
      on: { ok: _vm.confirm, cancel: _vm.close },
    },
    [
      _c(
        "div",
        { staticClass: "billing-configuration" },
        [
          _c(
            "a-input-group",
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("billing.invoiceEmailAddress"))),
              ]),
              _vm._v(" "),
              _c("a-input", {
                attrs: { placeholder: _vm.$t("billing.defaultRootEmail") },
                model: {
                  value: _vm.email,
                  callback: function ($$v) {
                    _vm.email = $$v
                  },
                  expression: "email",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }